<template>
  <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
    <van-list
      v-model="loading"
      :finished="finished"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
      finished-text="没有更多了"
      @load="getLogList">
      <van-cell v-for="item in logList" :key="item.id" :clickable="true" :is-link="true" :to="{ name: 'examResult', params: { id: item.id, ifTest: true }}">
        <template #default>
          分数: {{ item.user_score }}
        </template>
        <template #title > 
          {{ item.exam_name}} 
          <van-tag :type="item.user_score > item.pass_score ? 'success' : 'danger'" >{{ item.user_score > item.pass_score ? '通过' : '未通过' }}</van-tag>
        </template>
        <template #label>
          考试时间: {{ item.end_time }}
        </template>
      </van-cell>
    </van-list>
  </van-pull-refresh>
</template>

<script>
import { examGet } from '@/api/shopapi'
import { Toast } from 'vant'
export default {
  name: 'examLog',
  created () {},
  mounted () { this.getLogList() },
  data () {
    return {
      logList: [],
      loading: true,
      error: false,
      finished: false,
      refreshing: false
    }
  },
  methods: {
    async getLogList () {
      const data = await examGet({ "mode": 1, "page_no": 0, "page_size": 9999 })
      if (data.code === '000') {
        this.logList = data.data.data_list
      } else {
        Toast(data.message);
      }
      this.loading = false
      this.finished = true
      this.refreshing = false
    },
    onRefresh () {
      this.finished = false;
      this.loading = true;
      this.getLogList();
    }
  }

}
</script>

<style>
.icon-pass-extra::before {
  content: '\e626';
}

</style>